<template>
  <div class="composition-page">
    <screen-loader v-if="showLoaders"></screen-loader>
    <div v-else-if="timeoutMessage != ''" class="tabs-no-test-div timeout">
      <div class="text-center">
        {{ timeoutMessage }}
        <v-icon flat @click="loadItems()" color="blue-darken-3" icon="mdi-reload" size="large"></v-icon>
      </div>
    </div>
    <v-card-text class=" px-0 pb-0" v-else-if="hasRelevantData && serverItems.length > 0">
      <!-- <div class="pl-2">
        <v-switch
          v-if="serverItems.length > 0 && showLoaders == false"
          v-model="toggleFraction"
          color="info"
          :label="toggleFraction ? 'Mass %' : 'Mole %'"
          @change="toggleFractionFunction"
        ></v-switch>
      </div> -->
      <div class="composition-properties-wrap">
        <div class="chart-table-wrap">

          <div class="table-wrap  mt-0">
            <div class="table-title-div" v-if="serverItems.length > 0">
              <p class="table-title">Composition Properties</p>
              <div class="csv-btn" @click="downloadTableCSV('compositionProperties')">
                <v-img class="pointer" :src="documentDownload" alt="csv download"></v-img>
              </div>
            </div>
            <v-data-table :items="serverItems" :loading="loading" virtual-items>
              <!-- Main Header -->
              <template v-slot:headers>
                <tr class="main-header ">
                  <th class="" style="text-align: left !important">
                    Properties
                  </th>
                  <th class="">Flashed Gas</th>
                  <th class="">Flashed Liquid</th>
                  <th class="">Overall</th>
                </tr>
                <!-- Sub Header -->
                <tr class="sub-header">
                  <th style="text-align: left !important">Mole {{ moleFraction_UOM ? ` (${moleFraction_UOM})` : '' }}</th>
                  <th>{{ moleFraction_UOM || '' }}</th>
                  <th>{{ moleFraction_UOM || '' }}</th>
                  <th>{{ moleFraction_UOM || '' }}</th>
                </tr>
              </template>

              <!-- Table Body -->
              <template v-slot:body="{ items }">
                <tr v-for="(item, index) in items" :key="index">
                  <td style="text-align: left !important">
                    {{ item.fluidComponentReference }}
                  </td>
                  <td>
                    {{
                      displayValue("vapor_MoleFraction", item.vapor_MoleFraction)
                    }}
                  </td>
                  <td>
                    {{
                      displayValue(
                        "liquid_MoleFraction",
                        item.liquid_MoleFraction
                      )
                    }}
                  </td>
                  <td>
                    {{
                      displayValue(
                        "overall_MoleFraction",
                        item.overall_MoleFraction
                      )
                    }}
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-data-table :items="serverItems" :loading="loading" virtual-items>
              <!-- Main Header -->
              <template v-slot:headers>
                <tr class="main-header ">
                  <th class="" style="text-align: left !important">
                    Properties
                  </th>
                  <th class="">Flashed Gas</th>
                  <th class="">Flashed Liquid</th>
                  <th class="">Overall</th>
                </tr>
                <!-- Sub Header -->
                <tr class="sub-header">
                  <th style="text-align: left !important">Mass {{ massFraction_UOM ? ` (${massFraction_UOM})` : '' }}</th>
                  <th>{{ massFraction_UOM || '' }}</th>
                  <th>{{ massFraction_UOM || '' }}</th>
                  <th>{{ massFraction_UOM || '' }}</th>
                </tr>
              </template>

              <!-- Table Body -->
              <template v-slot:body="{ items }">
                <tr v-for="(item, index) in items" :key="index">
                  <td style="text-align: left !important">
                    {{ item.fluidComponentReference }}
                  </td>
                  <td>
                    {{
                      displayValue("vapor_MassFraction", item.vapor_MassFraction)
                    }}
                  </td>
                  <td>
                    {{
                      displayValue(
                        "liquid_MassFraction",
                        item.liquid_MassFraction
                      )
                    }}
                  </td>
                  <td>
                    {{
                      displayValue(
                        "overall_MassFraction",
                        item.overall_MassFraction
                      )
                    }}
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-data-table :items="serverItems" :loading="loading" virtual-items>
              <!-- Main Header -->
              <template v-slot:headers>
                <tr class="main-header ">
                  <th class="" style="text-align: left !important">
                    Properties
                  </th>
                  <th class="">Flashed Gas</th>
                  <th class="">Flashed Liquid</th>
                  <th class="">Overall</th>
                </tr>
                <!-- Sub Header -->
                <tr class="sub-header">
                  <th style="text-align: left !important">MolarMass {{ molarMass_UOM ? ` (${molarMass_UOM})` : '' }}</th>
                  <th>{{ molarMass_UOM || '' }}</th>
                  <th>{{ molarMass_UOM || '' }}</th>
                  <th>{{ molarMass_UOM || '' }}</th>
                </tr>
              </template>

              <!-- Table Body -->
              <template v-slot:body="{ items }">
                <tr v-for="(item, index) in items" :key="index">
                  <td style="text-align: left !important">
                    {{ item.fluidComponentReference }}
                  </td>
                  <td>
                    {{ displayValue("vapor_MW", item.vapor_MW) }}
                  </td>
                  <td>
                    {{ displayValue("liquid_MW", item.liquid_MW) }}
                  </td>
                  <td>
                    {{ displayValue("overall_MW", item.overall_MW) }}
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-data-table :items="serverItems" :loading="loading" virtual-items>
              <!-- Main Header -->
              <template v-slot:headers>
                <tr class="main-header ">
                  <th class="" style="text-align: left !important">
                    Properties
                  </th>
                  <th class="">Flashed Gas</th>
                  <th class="">Flashed Liquid</th>
                  <th class="">Overall</th>
                </tr>
                <!-- Sub Header -->
                <tr class="sub-header">
                  <th style="text-align: left !important">Density {{ density_UOM ? `(${density_UOM})` : '(g/cc)' }}</th>
                  <th>{{ density_UOM || 'g/cc' }}</th>
                  <th>{{ density_UOM || 'g/cc' }}</th>
                  <th>{{ density_UOM || 'g/cc' }}</th>
                </tr>
              </template>

              <!-- Table Body -->
              <template v-slot:body="{ items }">
                <tr v-for="(item, index) in items" :key="index">
                  <td style="text-align: left !important">
                    {{ item.fluidComponentReference }}
                  </td>
                  <td>
                    {{ displayValue("vapor_Density", item.vapor_Density) }}
                  </td>
                  <td>
                    {{ displayValue("liquid_Density", item.liquid_Density) }}
                  </td>
                  <td>
                    {{ displayValue("overall_Density", item.overall_Density) }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </div>
        <div class="table-wrap single-stage-table-wrap mt-0">
          <div class="table-title-div" v-if="serverItems.length > 0">
            <p class="table-title">Single Stage Flash Data</p>
            <div class="csv-btn" @click="downloadTableCSV('singleStageFlashData')">
              <v-img class="pointer" :src="documentDownload" alt="csv download"></v-img>
            </div>
          </div>
          <v-data-table :items="serverItems" :loading="loading" virtual-items fixed-header>
            <!-- Main Header -->
            <template v-slot:headers>
              <tr class="main-header">
                <th class=""></th>
                <th class="">Original STO</th>
              </tr>
              <!-- Sub Header -->
            </template>

            <!-- Table Body -->
            <template v-slot:body>
              <tr>
                <td style="text-align: left !important">GOR {{ flashGOR_UOM ? `(${flashGOR_UOM})` : '(variable)' }}</td>
                <td>
                  {{ flashGOR ? flashGOR : "-" }}
                </td>
              </tr>
              <tr>
                <td style="text-align: left !important">STO Density {{ liquidDensity_UOM ? `(${liquidDensity_UOM})` : '(g/cc)' }}</td>
                <td>
                  {{
                    displayValue("liquidDensity", liquidDensity)
                  }}
                </td>
              </tr>
              <tr>
                <td style="text-align: left !important">STO API Gravity {{ oilAPIGravity_UOM ? `(${oilAPIGravity_UOM})` : '' }}</td>
                <td>
                  {{
                    oilAPIGravity ? oilAPIGravity : "-"
                  }}
                </td>
              </tr>
              <tr>
                <td style="text-align: left !important">STO MW {{ oilMolecularWeight_UOM ? `(${oilMolecularWeight_UOM})` : '' }}</td>
                <td>
                  {{ oilMolecularWeight ? oilMolecularWeight : "-" }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </div>
    </v-card-text>
    <div v-else class="tabs-no-test-div">
      <h4>No data available.</h4>
    </div>
  </div>
</template>

<script>
import ScreenLoader from "../../Loaders/ScreenLoader.vue";
import { formatMetaNumericValue, getDisplayName, getSortOrder } from "../../../../utils/cache";
import api from "../../../../axiosInterceptor";
import { isPvtTestRoute } from "@/utils/pvtTestRoute";
export default {
  components: { ScreenLoader },
  name: "CompositionPropertiesTab",
  data: () => ({
    showLoaders: true,
    documentDownload: require("../../../../assets/Images/csv.svg"),
    itemsPerPage: 0,
    headers: [],
    serverItems: [],
    loading: true,
    totalItems: 0,
    testID: "",
    testName: "",
    sampleID: "",
    fluidSampleID: "",
    saturationPressure: "",
    saturationPressure_UOM: "",
    testTemperature: "",
    testTemperature_UOM: "",
    toggleFraction: false,
    timeoutMessage: "",
    flashGOR: "",
    flashGOR_UOM: "",
    liquidDensity: "",
    liquidDensity_UOM: "",
    oilAPIGravity: "",
    oilAPIGravity_UOM: "",
    oilMolecularWeight: "",
    oilMolecularWeight_UOM: "",
    compositionPropertiesHeader: {},
    moleFraction_UOM: "",
    massFraction_UOM: "",
    molarMass_UOM: "",
    density_UOM: "",
  }),
  computed: {
    isPvtTest() {
      return isPvtTestRoute(this.$route);
    },
    hasRelevantData() {
      if (this.toggleFraction) {
        return this.serverItems.some(
          (item) => item.overall_MassFraction !== undefined
        );
      } else {
        return this.serverItems.some(
          (item) => item.overall_MoleFraction !== undefined
        );
      }
    },
  },
  methods: {
    toggleFractionFunction() {
      this.serverItems = [];
      if (this.loading && this.serverItems.length === 0) {
        this.showLoaders = true;
      }

      this.loadItems();
    },
    async loadItems() {
      var sampleId = this.$route.params.sampleId;
      var compositionId = this.$route.params.id;
      this.loading = true;
      this.showLoaders = true;

      try {
        let response = await api.get(
          `public/api/samples/${sampleId}/compositiontests/${compositionId}`
        );
        if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
          this.serverItems =
            response.data.data.compositiontests &&
              response.data.data.compositiontests.compositionProperties
              ? response.data.data.compositiontests.compositionProperties
              : [];

          const properties = [
            "flashGOR",
            "flashGOR_UOM",
            "liquidDensity",
            "liquidDensity_UOM",
            "oilAPIGravity",
            "oilAPIGravity_UOM",
            "oilMolecularWeight",
            "oilMolecularWeight_UOM"
          ];

          for (const property of properties) {
            this[property] = response.data.data.compositiontests[property];

            if (!property.endsWith('_UOM')) {
              const displayNameData = await getDisplayName("compositiontests", property.charAt(0) + property.slice(1));
              this[property] = this.formatValue(this[property], displayNameData.digits);
            }
          }

          this.totalItems = response.data.data.compositiontests.length;
          this.testID = response.data.data.compositiontests.ID;
          this.compositionPropertiesHeader = response.data.data.pageData.compositionAnalysisHeader;
          this.sendDataToParent();

          const sortOrder = await getSortOrder("compositiontests", "composition_analysis", "table_for_mole");
          if (!sortOrder) {
            throw new Error("Sort order not found in cache.");
          }

          const sortByKeys = sortOrder.map((key) => key.charAt(0).toLowerCase() + key.slice(1));

          const availableKeys = new Set(
            sortByKeys.filter((key) =>
              this.serverItems.some((item) => key in item)
            )
          );

          const allKeys = sortByKeys.filter((key) => availableKeys.has(key));

          this.serverItems = this.serverItems.filter(
            (item) => item.fluidComponentReference !== "H2"
          );


          const allUniqueKeys = Array.from(allKeys);
          const displayNames = [];
          const digitsArray = [];

          await Promise.all(
            allUniqueKeys.map(async (key) => {
              const fullKey = `compositionProperties${key}`;
              const capitalizedKey = fullKey.charAt(0) + fullKey.slice(1);
              const { displayName, digits } = await getDisplayName("compositiontests", capitalizedKey);
              displayNames.push(displayName);
              digitsArray.push(digits);
            })
          );

          this.headers = Array.from(allKeys).map((key, index) => {
            const uom = this.serverItems.find((item) => item[key + "_UOM"]);
            const name = displayNames[index];
            let unit = uom ? uom[key + "_UOM"] : "-";
            if (!unit || unit === "data-not-available") {
              unit = "-";
            }
            const digits = digitsArray[index] || 0;
            return {
              key,
              name,
              unit,
              digits,
            };
          });


          const sortOrderMass = await getSortOrder("compositiontests", "composition_analysis", "table_for_mass");
          if (sortOrderMass && Array.isArray(sortOrderMass)) {
            const sortByKeysMass = sortOrderMass.map((key) => key.charAt(0).toLowerCase() + key.slice(1));

            const filteredKeysMass = sortByKeysMass.filter(
              (key) =>
                !this.headers.some((header) => header.key === key) &&
                this.serverItems.some((item) => key in item)
            );

            const displayNamesMass = [];
            const digitsArrayMass = [];

            await Promise.all(
              filteredKeysMass.map(async (key) => {
                const fullKey = `compositionProperties${key}`;
                const capitalizedKey = fullKey.charAt(0) + fullKey.slice(1);
                const { displayName, digits } = await getDisplayName("compositiontests", capitalizedKey);
                displayNamesMass.push(displayName);
                digitsArrayMass.push(digits);
              })
            );

            const massHeaders = filteredKeysMass.map((key, index) => {
              const uom = this.serverItems.find((item) => item[key + "_UOM"]);
              const name = displayNamesMass[index];
              let unit = uom ? uom[key + "_UOM"] : "-";
              if (!unit || unit === "data-not-available") {
                unit = "-";
              }
              const digits = digitsArrayMass[index] || 0;
              return {
                key,
                name,
                unit,
                digits,
              };
            });

            this.headers = [...this.headers, ...massHeaders];
          }

          this.extractUOMFromHeaders();

          return response.data.data.compositiontests;
        } else {
          this.timeoutMessage = "Error in fetching data";
        }
      } catch (error) {
        this.timeoutMessage = error;
      } finally {
        this.loading = false;
        this.showLoaders = false;
      }
    },

    formatValue(value, digits) {
      if (value === null || value === undefined) {
        return "-";
      }
      const formatted = formatMetaNumericValue(value, digits);
      return formatted == null || formatted === "" ? "-" : formatted;
    },

    extractUOMFromHeaders() {
      const moleFractionHeader = this.headers.find(header => header.key.includes('MoleFraction'));
      const massFractionHeader = this.headers.find(header => header.key.includes('MassFraction'));
      const molarMassHeader = this.headers.find(header => header.key.includes('MW'));
      const densityHeader = this.headers.find(header => header.key.includes('Density'));

      this.moleFraction_UOM = moleFractionHeader ? moleFractionHeader.unit : "";
      this.massFraction_UOM = massFractionHeader ? massFractionHeader.unit : "";
      this.molarMass_UOM = molarMassHeader ? molarMassHeader.unit : "";
      this.density_UOM = densityHeader ? densityHeader.unit : "";

      console.log('Extracted UOM values from headers:', {
        moleFraction_UOM: this.moleFraction_UOM,
        massFraction_UOM: this.massFraction_UOM,
        molarMass_UOM: this.molarMass_UOM,
        density_UOM: this.density_UOM
      });
    },

    displayValue(key, value) {
      if (value === null || value === undefined) {
        return "-";
      }
      const header = this.headers.find((header) => header.key === key);
      const formatted = formatMetaNumericValue(value, header ? header.digits : 0);
      return formatted == null || formatted === "" ? "-" : formatted;
    },
    async sendDataToParent() {
      const sortOrder = await getSortOrder("compositiontests", "composition_properties", "header");

      const headerData = [];

      if (this.compositionPropertiesHeader && Array.isArray(this.compositionPropertiesHeader)) {
        for (const item of this.compositionPropertiesHeader) {
          const key = item.key;
          const value = item.value;
          
          const [valueOnly, unit] = typeof value === 'string' ? value.split(' ') : [value, null];

          const capitalizedKey = key.charAt(0) + key.slice(1);

          let displayName, digits;
          try {
            const result = await getDisplayName("compositiontests", capitalizedKey);
            displayName = result.displayName;
            digits = result.digits;
          } catch (e) {
            displayName = undefined;
            digits = undefined;
          }

          if (!displayName) {
            displayName = key;
          }

          headerData.push({
            originalKey: key,
            value: valueOnly,
            displayName: displayName,
            digits: digits,
            unit: unit || null
          });
        }
      }

      this.$emit("data-updated", {
        compositionPropertiesHeader: headerData,
        sortOrder: sortOrder,
        originalData: this.compositionPropertiesHeader
      });
    },
    downloadTableCSV(tableType) {
      if (this.serverItems && this.serverItems.length > 0) {
        let fileName = '';
        let csvHeader = [];
        let csvUnits = [];
        let csvRows = [];

        if (tableType === 'compositionProperties') {
          fileName = `composition_properties_table.csv`;
          csvHeader = this.headers.map((header) => header.name);
          csvUnits = this.headers.map((header) => header.unit);
          csvRows = this.serverItems.map((item) =>
            this.headers.map((header) => item[header.key])
          );
        } else if (tableType === 'singleStageFlashData') {
          fileName = `single_stage_flash_data_table.csv`;
          csvHeader = ['Property', 'Value'];
          csvUnits = ['', ''];
          csvRows = [
            [`GOR ${this.flashGOR_UOM ? `(${this.flashGOR_UOM})` : '(variable)'}`, this.flashGOR ? this.flashGOR : "-"],
            [`STO Density ${this.liquidDensity_UOM ? `(${this.liquidDensity_UOM})` : '(g/cc)'}`, this.liquidDensity ? this.liquidDensity : "-"],
            [`STO API Gravity ${this.oilAPIGravity_UOM ? `(${this.oilAPIGravity_UOM})` : ''}`, this.oilAPIGravity ? this.oilAPIGravity : "-"],
            [`STO MW ${this.oilMolecularWeight_UOM ? `(${this.oilMolecularWeight_UOM})` : ''}`, this.oilMolecularWeight ? this.oilMolecularWeight : "-"]
          ];
          
          const csvContent = [
            csvHeader.join(","),
            ...csvRows.map((row) => row.join(",")),
          ].join("\n");
          
          const blob = new Blob([csvContent], {
            type: "text/csv;charset=utf-8;",
          });

          const link = document.createElement("a");
          if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            console.error(
              "Your browser does not support downloading files programmatically. Please try a different browser."
            );
          }
          return;
        }

        const csvContent = [
          csvHeader.join(","),
          csvUnits.join(","),
          ...csvRows.map((row) => row.join(",")),
        ].join("\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });

        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName); // Set filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.error(
            "Your browser does not support downloading files programmatically. Please try a different browser."
          );
        }
      } else {
        console.error("No data available in the table to download.");
      }
    },
    downloadCombinedCSV() {
      if (this.serverItems && this.serverItems.length > 0) {
        let fileName = 'combined_data_table.csv';
        let csvHeader = [];
        let csvUnits = [];
        let csvRows = [];

        csvHeader.push(...this.headers.map((header) => header.name));
        csvUnits.push(...this.headers.map((header) => header.unit));
        csvRows.push(...this.serverItems.map((item) =>
          this.headers.map((header) => item[header.key])
        ));

        const stoData = [
          ['Property', 'Value'],
          [`GOR ${this.flashGOR_UOM ? `(${this.flashGOR_UOM})` : '(variable)'}`, this.flashGOR ? this.flashGOR : "-"],
          [`STO Density ${this.liquidDensity_UOM ? `(${this.liquidDensity_UOM})` : '(g/cc)'}`, this.liquidDensity ? this.liquidDensity : "-"],
          [`STO API Gravity ${this.oilAPIGravity_UOM ? `(${this.oilAPIGravity_UOM})` : ''}`, this.oilAPIGravity ? this.oilAPIGravity : "-"],
          [`STO MW ${this.oilMolecularWeight_UOM ? `(${this.oilMolecularWeight_UOM})` : ''}`, this.oilMolecularWeight ? this.oilMolecularWeight : "-"]
        ];

        const csvContent = [
          csvHeader.join(","),
          csvUnits.join(","),
          ...csvRows.map((row) => row.join(",")),
          '', // Empty line separator
          ...stoData.map((row) => row.join(",")),
        ].join("\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });

        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName); // Set filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.error(
            "Your browser does not support downloading files programmatically. Please try a different browser."
          );
        }
      } else {
        console.error("No data available in the table to download.");
      }
    },

  },
  watch: {
    '$route': {
      handler() {
        this.loadItems();
      },
      immediate: true
    }
  },
  created() {
    if (this.isPvtTest) {
      this.toggleFraction = false;
    }
  },
  mounted() {
    this.loadItems();
  },
};
</script>